import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { getListTeam } from '../../actions/app.action';
import AdminLayoutWrapper from '../Admin/AdminLayoutWrapper'

class GuideLinePage extends React.Component {

  componentDidMount() {
    const teams = this.props.teams;
    if (teams.length === 0) {
      this.props.loadTeams();
    }
  }

  gotoHome = () => {
    this.props.history.push({ pathname: '/'});
  }


  render() {
    const teams = this.props.teams;

    return (
      <AdminLayoutWrapper>
        <div className="card-body">
          <h3>There are 3 easy steps to make your service APIs documents available on Altantis</h3>
          <div className="my-5">
            <h4>* First step</h4>
            <p className="my-2">Check your team existed on the this list, if not contact @viet.cao or @tuan.nguyen3 or @nghia.le on Slack:</p>
            <p>
              {
                teams && teams.map(team => {
                  return (
                    <p> - {team.name}</p>
                  )
                })
              }
            </p>
          </div>
          <div className="my-5">
            <h4>* Second step</h4>
            <p>
              On the Github repo root add a folder name <b>apidocs</b> in the root repository that contain 2 types of file:
              <div className="my-2">
                <p><b>+ service.yaml (required)</b>: contain metadata describe your service.</p>
                <pre>
                  <p>- teamName: The team choose on the list above</p>
                  <p>- serviceName: The name of your service, it uses as an Id to your service</p>
                  <p>- serviceOwners: The service owner's emails, for persion who view your docs have question to contract</p>
                  <p>- serviceDescription: The short description of what your service is and do</p>
                </pre>
                <p>Example: <a target="_blank" href="https://raw.githubusercontent.com/tikivn/pikachu/master/apidocs/service.yaml?token=AOWRQ2BVOIS4TIJJ5LSJZZS77PMUQ">https://github.com/tikivn/pikachu/blob/master/apidocs/service.yaml</a></p>
              </div>

              <div className="my-2">
                <p><b>+ xxx.yaml</b></p>
                <p>
                  Any number of API doc files your service might have (OpenAPI 3 specification supported). Your service can have multiple api docs as v1, v2 or admin, public docs files.
                </p>
                <p>The file name will use as ID for the API docs file (example: openapi-v1.yaml). You shouldn't change it otherwise the system will treat it as another API doc</p>
                <p>Example: <a target="_blank" href="https://raw.githubusercontent.com/tikivn/pikachu/master/apidocs/openapi-v1.yaml?token=AOWRQ2EDNN6KKF67CBZPLDK77PMYY">https://github.com/tikivn/pikachu/blob/master/apidocs/openapi-v1.yaml</a></p>
              </div>
            </p>
          </div>

          <div className="my-5">
            <h4>* Final step</h4>
            <p>
              <p>Grant Github user <b>tiki-atlantis</b> the read permission to your repository</p>
              <p>Open your repository on Github. Go to Settings --> Manange access --> Invite team or peope -> Enter tiki-atlantis</p>
            </p>
          </div>

          <div className="alert alert-primary" role="alert">
            After that when you API docs is merged and your repo got deploy to UAT or PROD, the Jenkin will fire events for Atlantis to crawl the lastest docs from your repo.
          </div>

          <div>
            References:
            <p>
              - OpenAPI 3 generator for Lavarel: <a target="_blank" href="https://vyuldashev.github.io/laravel-openapi">https://vyuldashev.github.io/laravel-openapi</a>
              </p>
            <p>
              - OpenAPI 3 generator for Spring: <a target="_blank" href="https://springdoc.org">https://springdoc.org</a>
            </p>
          </div>
        </div>
      </AdminLayoutWrapper>
    )
  }
}

const mapStateToProps = state => ({
  teams: state.app.teams,
  user: state.app.user
});

const mapPropsToDispatch = dispatch => ({
  loadTeams: () => dispatch(getListTeam()),
});

export default withRouter(connect(mapStateToProps, mapPropsToDispatch)(GuideLinePage));